module.exports = __webpack_public_path__ + "media/application/images/2018/2018-accordian-arrow-19f4eccd07d5b4a3596ca1501abd2230.svg";